var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"straight-title":_vm.additionalModuleName,"module-enabler":_vm.moduleEnabler,"has-buttons":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }